import React from "react"
import { Tag, Tooltip } from "antd"
import { useDummyData } from "../api/useDummyData"

interface Props {
  /** The project; undefined reads nothing (a project without a questionnaire). */
  projectId?: string
  /** Explains the badge on hover; off where the same words already show beside it. */
  tooltip?: boolean
}

/** "Dummy data", while the project's data is dummy data generated for testing. */
const DummyBadge: React.FC<Props> = ({ projectId, tooltip = true }) => {
  const { isActive } = useDummyData(projectId)
  if (!isActive) return null
  // The places it sits in space their items, so the tag keeps no margin of its own.
  const tag = (
    <Tag color="gold" style={{ marginInlineEnd: 0 }} data-testid="dummy-badge">
      Dummy data
    </Tag>
  )
  return tooltip ? (
    <Tooltip title="This project's data was generated for testing. Remove it in Data Import before importing real data.">
      {tag}
    </Tooltip>
  ) : (
    tag
  )
}

export default DummyBadge
